import * as React from "react";
import { useDispatch } from "@teamprevent/employee-redux";

import { loadImmunisations } from "../actions";

import { All } from "./All";
import { ImmunisationRecord } from "./ImmunisationRecord";

import { Fragment } from "redux-little-router";

export const Base: React.FunctionComponent = () => {
    const dispatch = useDispatch();

    React.useEffect(() => {
        dispatch(loadImmunisations());
    }, [dispatch]);

    return (
        <div>
            <Fragment forRoute="/immunisationRecord">
                <ImmunisationRecord />
            </Fragment>
            <Fragment forRoute="/">
                <All />
            </Fragment>
        </div>
    );
};
